import { Injectable } from '@angular/core';

import {
    DynamicValue, DynamicObjects, DynamicComponent, GenericValue,
    GUIComponentField, GUIComponent, HisUiService, HisGenericValueService,
    HisBaseGlobalsService } from 'hisng';

import { DynamicContentUtils } from './dynamic-content-utils';
import { DynamicAttributeSummarizedItem } from '../../model/dynamic-viewitem/DynamicAttributeSummarizedItem';
import { DatePipe } from '@angular/common';
import { Observable, flatMap, forkJoin, map, tap } from 'rxjs';

@Injectable()
export class DynamicFieldValueUtils {

    constructor( private hisUiService: HisUiService,
        private dynamicContentUtils: DynamicContentUtils,
        private genericValueService: HisGenericValueService,
        public hisBaseGlobalsService: HisBaseGlobalsService ) {
    }

    /* set keytableValue for dynamicField with genericValueService */
    public setDynamicFieldKeyTableValues(dynamicObjects: DynamicObjects[], keyTableFieldIdValueMap: Map<string, string>){
	    const allObservables: Observable<GenericValue[]> [] = [];
  
        dynamicObjects.forEach( (dynamicObject: DynamicObjects) => {
            if ( dynamicObject.values.length !== null ) {
	           let considerableValues = dynamicObject.values.filter( ( dynamicValue: DynamicValue ) => 
                    ( dynamicValue.source && dynamicValue.source !== 'y/n' &&  dynamicValue.source !== 'cb' ));
                         
                considerableValues.forEach( dynamicValue => { 
                    if (dynamicValue.value){
	                    let obs = this.genericValueService.getValueTypes( dynamicValue.source ).pipe(
	                        tap((valueTypes: GenericValue[]) => { 
                                let gValueDefaulttext = '';
                                valueTypes.forEach( (valueType: GenericValue ) => {
                                    if ( dynamicValue.value && dynamicValue.value.split(',').includes( '' + valueType.id ) ) {
                                        gValueDefaulttext = gValueDefaulttext + ', ' + valueType.defaulttext;
                                    }
                                });
	                            keyTableFieldIdValueMap.set( dynamicValue.attributeName, gValueDefaulttext.substring( 1, gValueDefaulttext.length ) );
	                        }));
	                    allObservables.push(obs);
	                }
	               });
            }
        });
        return forkJoin(allObservables);
    }

    public getKeyTableDatasource( dynamicObjects: DynamicObjects[], dynamicField: GUIComponentField ): string {
        if ( dynamicField ) {
            let typeValueSource = this.dynamicContentUtils.getDynamicObjectAttribute(
                dynamicObjects, dynamicField.objectUID, dynamicField.attributeName, 'source' );
            return typeValueSource !== 'y/n' && typeValueSource !== 'cb' ? typeValueSource : null;
        }
        return undefined;
    }

    public getDynamicFieldSimpleValue( dynamicObjects: DynamicObjects[], dynamicField: GUIComponentField ): string {
        let dynamicObjectValue = this.dynamicContentUtils.getDynamicObjectAttribute(
            dynamicObjects, dynamicField.objectUID, dynamicField.attributeName, 'value' );
        if ( dynamicObjectValue === '0' || dynamicObjectValue === '1' ) {
            return dynamicObjectValue === '0'
                ? this.hisUiService.translate( 'de.his.javang.nein.lowercase' )
                : this.hisUiService.translate( 'de.his.javang.ja.lowercase' );
        } else {
            return dynamicObjectValue;
        }
    }

    /* get key table value of dynamicField */
    public getDynamicFieldKeyTableValue( dynamicObjects: DynamicObjects[], dynamicField: GUIComponentField,
        keyTableFieldIdValueMap: Map<string, string> ): string {
        if ( this.getKeyTableDatasource( dynamicObjects, dynamicField ) ) {
            return keyTableFieldIdValueMap.get( dynamicField.attributeName );
        }
        return undefined;
    }
    
    public buildDynAttributesList(rootClassName: string, rootGuiObjectName: string, dynComponent: DynamicComponent, keyTableFieldIdValueMap: Map<string, string> ): DynamicAttributeSummarizedItem[]  {             
        //if (keyTableFieldIdValueMap.size==0)return [];        
        let dynAttributesList: DynamicAttributeSummarizedItem[]=[];
        //let rootclassName= 'fs.res.project.Project'; //test für projekt first 	                
               
        if (dynComponent) {
            let dynObjects = dynComponent.dynamicObjects;
            let rootGuiObj = dynComponent.guiComponent?.children.filter(guiChild => guiChild.name ===rootGuiObjectName);

            if(rootGuiObj?.length>0){
    			for(let guiFieldset of rootGuiObj[0].children) { //z.B. tab =fs.res.maindata    			
    				let item = this.buildDynamicFiledValueList(rootClassName, guiFieldset, dynComponent, dynObjects, keyTableFieldIdValueMap );
    				if (item && !item.isHidden && (item.value || item.children.length >0 )){
                        dynAttributesList.push(item);
                    }
    			}
    			
    			let moreItems = this.buildDynamicFiledValueList(rootClassName, rootGuiObj[0], dynComponent, dynObjects, keyTableFieldIdValueMap );
    			if (moreItems && (moreItems.value || moreItems.children.length >0)){
                    dynAttributesList.push(moreItems);
    			}
            }
        }
        return dynAttributesList;
    }    
    
    public buildDynamicFiledValueList(rootClassName: string, guiFieldset: GUIComponent, dynComponent: DynamicComponent , dynObjects: DynamicObjects[], keyTableFieldIdValueMap: Map<string, string> ): DynamicAttributeSummarizedItem{
	    let parentItem: DynamicAttributeSummarizedItem = new DynamicAttributeSummarizedItem() ;	    	
	    if(guiFieldset ===null) {return parentItem;}
	    
	    
	    let dDContexts: string[]= dynComponent.conditions.contexts;
	    let dynamicFieldItems: DynamicAttributeSummarizedItem[]=[];
	    
	    for(let field of guiFieldset.fields.sort((f1:any, f2:any) => f1.sortorder -f2.sortorder)){
            if (field.ddKey && ( !this.hisBaseGlobalsService.getDd(field.ddKey, dDContexts) || !this.hisBaseGlobalsService.getDd(field.ddKey, dDContexts).hidden ) ) {
                let dynObj = dynObjects.find(c =>
                    c.objGuid === field.objectUID
                    //c.objGuid === field.objectUID && c.dynamicClassName == guiFieldset.name
                );
                if (dynObj) {
                    const val = dynObj.values.find(v => v.attributeName === field.attributeName);
                    if (val) {
                        let fieldValue: string;
                        if (this.getKeyTableDatasource(dynComponent.dynamicObjects, field)){
                            fieldValue= this.getDynamicFieldKeyTableValue(dynObjects, field, keyTableFieldIdValueMap);
                        } else if ( field.controlType === 'YesNoSelect' ) {
                            fieldValue = this.getDynamicFieldSimpleValue(dynComponent.dynamicObjects, field);
                        } else if ( field.controlType === 'DatePicker' ) {
                            fieldValue = new DatePipe('de').transform( this.getDynamicFieldSimpleValue(dynComponent.dynamicObjects, field), this.hisUiService.translate('common.dateFormat') );
                        } else if ( !fieldValue ) {
                            fieldValue = val.value;
                        }
                        if (fieldValue){
                            let item: DynamicAttributeSummarizedItem = new DynamicAttributeSummarizedItem();
                            item.isFieldSet =false;
                            item.isHidden = false;
                            item.label = field.label;
                            item.position = field.position;
                            item.sortorder = field.sortorder;
                            item.value = fieldValue;
                            item.oldValue = val.oldValue;
                            item.useOldValue = val.useOldValue;
                            item.rightLevel =field.rightLevel;
                            item.parent = parentItem;
                    
                            dynamicFieldItems.push(item);
                        }
                    }
                }
            }    
        }
 
        if (dynamicFieldItems?.length>0){
            parentItem.isFieldSet =true;
            parentItem.position= guiFieldset.position;
            parentItem.children.push(...dynamicFieldItems);
            parentItem.label = guiFieldset.name;
            parentItem.rightLevel = guiFieldset.rightLevel;
            parentItem.isHidden =false;
        }
        return parentItem;
    }

    public getDynamicItemsForPosition(dynamicAttributeItems: DynamicAttributeSummarizedItem[], fieldsetname: string,pos: number): DynamicAttributeSummarizedItem[]  {
        let result: DynamicAttributeSummarizedItem[]= new Array<DynamicAttributeSummarizedItem>();
        if(dynamicAttributeItems?.length>0 ) {
	        dynamicAttributeItems.forEach( (item)=> {
                if( item.isFieldSet && item.label=== fieldsetname ) {
                    if ( item.children.length >0 ) {
					    item.children.forEach( child => {
                            if (child.sortorder === pos){
                                result.push(child);
                       		}});
                    }
		   		} 
            });
        
	    }
	    return result.sort((itm1,itm2)=> itm1.sortorder - itm2.sortorder );
    }
    
    public getDynamicItemsForAnkerPosition(dynamicAttributeItems:DynamicAttributeSummarizedItem[] , pos: number): DynamicAttributeSummarizedItem[]  {
        let result: DynamicAttributeSummarizedItem[]= new Array<DynamicAttributeSummarizedItem>();
        if(dynamicAttributeItems && dynamicAttributeItems.length>0 ) {
            dynamicAttributeItems.forEach( (item)=> {
                if( item.isFieldSet && item.position === pos && item.children.length >0 ) {
                    result.push(item);
                } 
            });
        }
        return result;
    }

}
